import { useQuery } from '@tanstack/react-query';
import { attributionApi } from '@/api/attributionApi';
import { useUIStore } from '@/state/uiStore';
import css from './forms.module.css';

export function FundSelector() {
  const fund = useUIStore((s) => s.selectedFund);
  const setFund = useUIStore((s) => s.setSelectedFund);
  const q = useQuery({
    queryKey: ['funds'],
    queryFn: attributionApi.funds,
    staleTime: Infinity,
  });

  return (
    <div className={css.field}>
      <label htmlFor="fund-select" className={css.label}>Fund</label>
      <select
        id="fund-select"
        className={css.select}
        value={fund}
        onChange={(e) => setFund(e.target.value)}
        disabled={q.isLoading}
      >
        {(q.data ?? [{ code: fund, displayName: fund }]).map((f) => (
          <option key={f.code} value={f.code}>{f.displayName}</option>
        ))}
      </select>
    </div>
  );
}
